import React from 'react';

import { FormattedMessage } from 'react-intl';

import {
  DashboardLink,
  PreviousPageLink,
} from 'src/components/error-page/components/common';

import CustomizedErrorState from '../customized-error-state';

import messages from './i18n';

type Props = {
  title?: string;
};

export const NotFoundState = ({ title }: Props): JSX.Element => {
  return (
    <CustomizedErrorState
      title={
        title === undefined ? <FormattedMessage {...messages.title} /> : title
      }
    >
      <FormattedMessage
        {...messages.errorHelpMessage}
        values={{
          previousPageLink: <PreviousPageLink />,
          dashboardLink: <DashboardLink />,
        }}
        tagName="p"
      />
    </CustomizedErrorState>
  );
};
